module.exports = __webpack_public_path__ + "static/media/teens.9064e842.png";